export const tokenUrl = 'https://customer.hirsch.com/v1/token'

export const loginUrl = 'https://customer.hirsch.com/account/v1/employee'

// export const loginUrl = 'http://dev.customer.hirsch.local/account/v1/employee'

export const orderDetailUrl = 'https://customer.hirsch.com/order/v1/details'

export const ordersUrl = 'https://customer.hirsch.com/picking/v1/list'